import { Component, OnInit, SkipSelf, ChangeDetectorRef } from '@angular/core';
import { BaseControlComponent } from '../../../../../../form-controls/components/base-control/base-control.component';
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';


@Component({
    selector: 'app-boolean-display-config',
    templateUrl: './boolean-display-config.component.html',
    styleUrls: ['./boolean-display-config.component.scss'],
    standalone: false
})
export class BooleanDisplayConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = 'booleanDisplayConfigComponent';

    displayOptions = [
        { type: "Yes/No", checked: "Yes", unChecked: "No" },
        { type: "True/False", checked: "True", unChecked: "False" },
        { type: "Other", checked: "", unChecked: "" }
    ]

    get defaultValue(): string {
        return <string>this.componentData.config.defaultValue;
    }

    set defaultValue(value: string) {
        this.componentData.config.defaultValue = value;
    }

    get summaryDisplayType(): string {
        return <string>this.componentData.config.summaryDisplay.type;
    }

    set summaryDisplayType(value: string) {
        this.componentData.config.summaryDisplay.type = value;
    }

    get summaryOptionOtherChecked(): string {
        return this.componentData.config.summaryDisplay.otherChecked;
    }

    set summaryOptionOtherChecked(value: string) {
        this.componentData.config.summaryDisplay.otherChecked = value;
    }

    get summaryOptionOtherUnchecked(): string {
        return this.componentData.config.summaryDisplay.otherUnchecked;
    }

    set summaryOptionOtherUnchecked(value: string) {
        this.componentData.config.summaryDisplay.otherUnchecked = value;
    }

    get useDefaultValue(): boolean {
        if (this.componentData.config.useDefaultValue === undefined || this.componentData.config.useDefaultValue === null) {
            this.componentData.config.useDefaultValue = false;
        }
        return <boolean>this.componentData.config.useDefaultValue;
    }

    set useDefaultValue(value: boolean) {
        this.componentData.config.useDefaultValue = value;
    }

    constructor(@SkipSelf() public changeDetectorRef: ChangeDetectorRef, public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        if (this.componentData.config.summaryDisplay === undefined || this.componentData.config.summaryDisplay === null) {
            this.componentData.config.summaryDisplay = { type: "Yes/No", otherChecked: "", otherUnchecked: "" };
        }
        if (this.componentData.config.defaultValue === undefined || this.componentData.config.defaultValue === null) {
            this.componentData.config.defaultValue = "unchecked";
        }
    }

    changeDefault(): void {
        this.changeDetectorRef.detectChanges();
    }
}